export default "__VITE_ASSET__b64a022f__"